/**
 * The coach's request that a current client take the Wheel of Life. The
 * request is an ordinary message in the engagement thread whose last line is
 * the request link; the thread renders that line as a button, and the coach's
 * Wheel card finds the latest request by the link. Universal: safe on client
 * and server.
 *
 * Aliases: wheel request, send the wheel, wheel request message
 */

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** The engagement id from a `?engagement=` search value, or undefined. */
export function parseEngagementSearch(value: unknown): string | undefined {
  return typeof value === "string" && UUID.test(value) ? value : undefined;
}

/** The platform Wheel, opened for one engagement's request. */
export function wheelRequestPath(engagementId: string): string {
  return `/wheel-of-life?engagement=${engagementId}`;
}

export const WHEEL_REQUEST_TEXT =
  "Before our next session, could you take the Wheel of Life? It takes about five minutes. You'll see your results first and choose whether to share them with me.";

export function wheelRequestMessage(
  appUrl: string,
  engagementId: string,
): string {
  return `${WHEEL_REQUEST_TEXT}\n\n${appUrl}${wheelRequestPath(engagementId)}`;
}

const REQUEST_LINE =
  /\n\n\S*\/wheel-of-life\?engagement=([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i;

/**
 * Splits a request message into its text and the in-app path of its link,
 * or returns null for any other message. The path is rebuilt from the
 * engagement id, so the button never follows a host typed into the message.
 */
export function parseWheelRequestMessage(
  content: string,
): { text: string; path: string } | null {
  const match = REQUEST_LINE.exec(content);
  if (!match) return null;
  return {
    text: content.slice(0, match.index),
    path: wheelRequestPath(match[1].toLowerCase()),
  };
}
